import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'momentDate'
})
export class MomentDatePipe implements PipeTransform {
  transform(value: any, format: string = 'h:mm A', timezone: string = 'Europe/Ljubljana', locale: string = 'sl'): string {

    // Map Angular's format to moment's format
    const formatMapping = {
        'shortTime': 'LT',
        'fullDate': 'dddd, DD. MMMM YYYY'
        // ... add other mappings as needed ...
    };

    const momentFormat = formatMapping[format] || format;

    moment.locale(locale);
    return moment(value).tz(timezone).format(momentFormat);
  }
}